import { Mention } from '@design/chat/mention-composer';
import { getTimeTillEndOfDayMs } from '@helpers/utils/dates/getTimeTillEndOfDayMs';
import { useQuery } from '@tanstack/react-query';
import { refinePrompt } from '@terminal/services/prompt-refinement/prompt-refinement-service';
import { useFlags } from '@terminal/stores/use-flags/useFlags';

const QUERY_KEY_REFINE_PROMPT = 'QUERY_KEY_REFINE_PROMPT';

interface UseRefinePromptQueryParams {
  question: string;
  mentions?: Mention[];
  isEnabled: boolean;
}

export const useRefinePromptQuery = ({
  question,
  mentions,
  isEnabled,
}: UseRefinePromptQueryParams) => {
  const mentionsEnabled = useFlags(state =>
    state.getFeatureFlagState('REASON-2103-alfred-mentions')
  );
  const trimmedQuestion = question.trim();
  const mentionKey = mentions?.map(mention => `${mention.type}:${mention.id}`);

  return useQuery({
    queryKey: [
      QUERY_KEY_REFINE_PROMPT,
      trimmedQuestion,
      mentionsEnabled,
      mentionKey,
    ],
    queryFn: ({ signal }) =>
      refinePrompt({
        question: trimmedQuestion,
        mentions,
        mentionsEnabled,
        signal,
      }),
    enabled: isEnabled && !!trimmedQuestion,
    staleTime: getTimeTillEndOfDayMs(),
    retry: false,
  });
};
